// @flow
import React from "react"
import TiArrowRight from "react-icons/lib/ti/arrow-right"
import { rhythm } from "../utils/typography"
import { white, accent, accentAlt } from "../utils/colors"
import g2CrowdBadge from "../images/g2crowd-badge.svg"

const CustomerRatingBar = () => (
  <div css={styles.customerRatingBar}>
    <div css={styles.visual}>
      <img src={g2CrowdBadge} />
    </div>
    <div css={styles.body}>
      <h4 css={styles.text}>
        EaseCentral is the top rated broker-powered employee benefits system on
        G2Crowd.
        <a
          css={styles.link}
          href="https://www.g2crowd.com/products/easecentral/reviews"
          target="_blank"
          rel="noopener noreferrer"
        >
          Read over 90 customer reviews on G2Crowd <TiArrowRight />
        </a>
      </h4>
    </div>
  </div>
)

const styles = {
  customerRatingBar: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: `${rhythm(3)} 0`,
    "@media screen and (min-width: 570px)": {
      flexDirection: "row",
    },
  },
  visual: {
    flex: "0 1 11.375em",
    "@media screen and (min-width: 570px)": {
      "> img": {
        marginBottom: 0,
      },
    },
  },
  body: {
    flex: "1",
    maxWidth: "38em",
    "@media screen and (min-width: 570px)": {
      paddingLeft: rhythm(2),
    },
  },
  text: {
    color: white,
    fontWeight: "600",
    WebkitFontSmoothing: "antialiased",
    margin: 0,
  },
  link: {
    display: "block",
    marginTop: rhythm(),
    fontWeight: "700",
    color: accent,
    textDecoration: "none",
    "&:hover": {
      color: accentAlt,
    },
  },
}

export default CustomerRatingBar



// WEBPACK FOOTER //
// ./src/components/CustomerRatingBar.js